export default __webpack_public_path__ + "static/sortby-b89857441c4826f3ed1934f756059885.gif";